import { render } from "./MButtonFontIcon.vue?vue&type=template&id=267844f1&scoped=true"
import script from "./MButtonFontIcon.vue?vue&type=script&lang=js"
export * from "./MButtonFontIcon.vue?vue&type=script&lang=js"

import "./MButtonFontIcon.vue?vue&type=style&index=0&id=267844f1&scoped=true&lang=css"

import exportComponent from "D:\\NVManh\\Github\\MS.eShop\\eShopV2\\web-thaisalon\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-267844f1"]])

export default __exports__